import { getRoot } from "mobx-state-tree";

export const scrapersStoreViews = self => ({
  get token() {
    return getRoot(self).authStore.token;
  }
});
